import { Avatar, Flex, Rate, Tag } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import classes from "./doctorItem.module.css";

const DoctorItem = ({ doctor } : { doctor: {
  id: string,
  name: string,
  surname: string,
  photo?: string,
  studies?: string,
  skills?: {
    name: string
  }[],
  feedbacksManual: {
    id: string
  }[],
  feedbacks: {
    professionist: number
  }[]
  feedbackAvg: number
} }) => {
  return (
    <Link
      to="/book"
      state={{ doctor }}
      className="flex p-[1.5rem] bg-[#F0F3F8] rounded-[16px] gap-[16px]"
    >
      <Avatar
        className={`!text-5xl text-white bg-[#4071AB] !border-none flex-shrink-0 ${classes.avatar}`}
        src={(doctor.photo ? <img draggable={false} src={doctor.photo} className="w-full h-full" alt="avatar" /> : <UserOutlined />)}
      />
      <Flex vertical className="grow">
        <Flex justify="between">
          <Flex vertical gap={8} className="mb-[8px] text-black">
            <span className="text-xl font-bold">{doctor.name} {doctor.surname}</span>
            <span>{doctor.studies}</span>
          </Flex>
          {doctor.feedbacks.length || doctor.feedbacksManual.length ? (
            <Flex vertical align="end" className="ml-auto flex-shrink-0 pt-[10px]">
              <Rate
                disabled
                value={doctor.feedbackAvg}
                className="text-sm text-[#78D8D4]"
              />
              <span className="text-sm underline text-black">
                {`${doctor.feedbacks.length + doctor.feedbacksManual.length} valutazioni`}
              </span>
            </Flex>
          ) : null}
        </Flex>
        <Flex gap={8} wrap="wrap">
          {doctor.skills?.map((skill: { name: string }) => (
            <Tag key={skill.name} className="bg-white text-[#03AEBF] font-bold text-md uppercase rounded-xl py-[4px] px-[13px] border-none">
              {skill.name}
            </Tag>
            ))}
        </Flex>
      </Flex>
    </Link>
  );
};

export default DoctorItem;
